import { render } from "./index.vue?vue&type=template&id=f8f1e0e4"
import script from "./profile.js?vue&type=script&lang=js&external"
export * from "./profile.js?vue&type=script&lang=js&external"

import "./profile.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__